import Image from '@components/ui/image';
import { getKosherImageURL, Product } from '@framework/types';
import { FC } from 'react';

export const KosherIcon: FC<{
  width?: string | number;
  height?: string | number;
  product: Product;
}> = ({ width, height, product }) => {
  return (
    <>
      {product?.kosher && (
        <span
          style={{
            width: width ?? 80,
            height: height ?? 80,
            borderRadius: '50%',
            placeContent: 'center',
            padding: 10,
            border: '2px solid black',
            background: 'white',
          }}
          className="flex"
        >
          <Image
            src={getKosherImageURL(product.kosher)!!}
            fallbackImage={'/assets/images/kosher/generic-kosher-type.png'}
            showLoader={false}
            alt={product.kosher.toLowerCase()}
          />
        </span>
      )}
    </>
  );
};
